import React from 'react'
import { MotifProgressLoader } from '@ey-xd/motif-react'

type ProgressLoaderTypes = {
    show: boolean,
    style?: any,
}

const ProgressLoader: React.FC<ProgressLoaderTypes> = (props: ProgressLoaderTypes) => {
	const {show, style} = props

	return (
		<div style={{position : 'absolute', ...style}}>
			<MotifProgressLoader show={show} />
		</div>
	)
}

ProgressLoader.defaultProps = {
	show: true,
}

export default  ProgressLoader